export default {"src":"/_next/static/media/spectral.6d51750c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};